import React from 'react';
import Proptypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { FilterNames } from '../../types/trade';

import { FilterDisplay, SelectedOption, ArrowDownIcon } from './Styles';

const propTypes = {
  openDropDown: Proptypes.func.isRequired,
  title: Proptypes.string,
  testId: Proptypes.string
};

const defaultProps = {
  testId: '',
  title: ''
};

const FilterDisplayBox = React.forwardRef((props, ref) => {
  return (
    <FilterDisplay
      ref={ref}
      data-testid={props?.testId}
      onClick={props?.openDropDown}
    >
      <SelectedOption isAll={props.id === FilterNames.all.id}>
        {props.id === FilterNames.all.id ? (
          <FormattedMessage id="tr5.select" />
        ) : (
          props?.title
        )}
      </SelectedOption>
      <ArrowDownIcon />
    </FilterDisplay>
  );
});

FilterDisplayBox.propTypes = propTypes;
FilterDisplayBox.defaultProps = defaultProps;

export default FilterDisplayBox;
